<template>
  <transition name="app-mobile-menu">
    <div class="app-mobile-menu" v-if="mobileMenuOpened">
      <div class="app-mobile-menu__content-wrap">
        <div class="app-mobile-menu__content">
          <search-bar theme="menu"></search-bar>
          <template v-if="isLoggedIn && showBalanceHeader">
            <div
              id="menu-investment"
              @click.prevent="onInvestmentClick"
              class="app-mobile-menu__menu-item app-mobile-menu__menu-item--investment"
            >
              <div class="app-mobile-menu__menu-item-text">Investment</div>
              <div
                class="app-mobile-menu__menu-item-value"
                v-price-display.floor.fixed="balance.portfolioBalanceDecimal"
              ></div>
            </div>
            <div
              id="menu-cash"
              @click.prevent="onCashClick"
              class="app-mobile-menu__menu-item app-mobile-menu__menu-item--cash"
            >
              <div class="app-mobile-menu__menu-item-text">Cash</div>
              <div
                class="app-mobile-menu__menu-item-value"
                v-price-display.floor.fixed="balance.accountBalanceDecimal"
              ></div>
            </div>
            <div
              id="menu-deposit"
              class="app-mobile-menu__menu-item app-mobile-menu__menu-item--deposit"
              @click.prevent="openDepositPopup"
            >
              <div class="app-mobile-menu__menu-item-text">Deposit</div>
              <div
                class="app-mobile-menu__menu-item-icon app-mobile-menu__menu-item-icon--deposit"
              ></div>
            </div>
          </template>
          <template v-else-if="!isLoggedIn">
            <div
              id="menu-signup"
              v-if="!isUserRestricted"
              class="app-mobile-menu__menu-item app-mobile-menu__menu-item--register"
              @click="onSignUp"
            >
              <div class="app-mobile-menu__menu-item-text">Sign Up</div>
            </div>
            <div
              id="menu-login"
              class="app-mobile-menu__menu-item app-mobile-menu__menu-item--login"
              @click="onLogin"
            >
              <div class="app-mobile-menu__menu-item-text">Login</div>
            </div>
          </template>
          <div class="app-mobile-menu__nav">
            <router-link
              v-for="item in enabledLinks"
              :key="`menu-nav-${item.name}`"
              :to="item.href"
              custom
              v-slot="{ navigate }"
            >
              <div
                :id="`menu-nav-${item.name}`"
                :class="itemClassModifiers(item)"
                @click="
                  (e) => {
                    onLinkClick(item.href);
                    navigate(e);
                  }
                "
              >
                <div class="app-mobile-menu__nav-item-text">
                  {{ item.title.toString() }}
                </div>
                <account-social-avatar
                  v-if="item.name === 'dashboard'"
                  theme="mobile-menu"
                  :avatar="userAvatar"
                  :showProgress="true"
                  :percentage="100"
                  :progressStrokeColor="levelColorWithRespectToNav"
                  :showEdit="false"
                >
                </account-social-avatar>
                <div v-else :class="itemIconClassModifiers(item)"></div>
              </div>
            </router-link>
            <div class="app-mobile-menu__nav-item" @click="logoutButton" v-if="isLoggedIn">
              <div class="app-mobile-menu__nav-item-text">LOGOUT</div>
              <div
                class="app-mobile-menu__nav-item-icon app-mobile-menu__nav-item-icon--logout"
              ></div>
            </div>
          </div>
        </div>
        <div class="app-mobile-menu__classic-exchange" v-if="false">
          <div class="app-mobile-menu__classic-exchange__content">
            <div class="app-mobile-menu__classic-exchange__mask" @click="showLeavingPopup"></div>
            <div class="app-mobile-menu__classic-exchange__bar"></div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script src="./app-mobile-menu.js"></script>
<style src="./app-mobile-menu.scss" lang="scss"></style>
